import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import NavCategory from './NavCategory';
import MoreDropdown from './MoreDropdown';
import { CategoryContainer } from './navCategoryBarStyles';

class NavCategoryBar extends PureComponent {
	render() {
		const {
			navigationItems,
			currentSlug,
			amp,
			onMouseEnter,
			onMouseLeave,
			categoryMouseEnter,
			categoryMouseLeave,
		} = this.props;

		return (
			<CategoryContainer
				onMouseLeave={onMouseLeave}
				onMouseEnter={onMouseEnter}>
				{navigationItems.map(navItem => (
					<NavCategory
						key={`navItem-${navItem.slug}`}
						windowSlug={currentSlug}
						icon={navItem.slug === "gifting"}  // gross
						onMouseEnter={categoryMouseEnter(navItem.slug, navItem)}
						onMouseLeave={categoryMouseLeave}
						{...navItem}
					/>
				))}
				{!amp && <MoreDropdown navItems={navigationItems} />}
			</CategoryContainer>
		);
	}

	static propTypes = {
		onMouseEnter: PropTypes.func,
		onMouseLeave: PropTypes.func,
		categoryMouseEnter: PropTypes.func,
		categoryMouseLeave: PropTypes.func,
		navigationItems: PropTypes.array.isRequired,
		currentSlug: PropTypes.string,
		amp: PropTypes.bool.isRequired,
	};

	static defaultProps = {
		campaigns: [],
		amp: false,
	}
}

export default NavCategoryBar;
